export const Config = {
    email: 'contato@clickmob.com.br',
    whatsappLink: 'https://wa.me/61981758818',
    instagramLink: 'https://www.instagram.com/',
    linkedinLink: 'https://www.linkedin.com/in/christian-soares-98445a205/',
    emailLink: 'mailto:contato@clickmob.com.br',
}